/**
 * @generated SignedSource<<4ccee80dbccc7b7a65e413848441bce6>>
 * @relayHash ebda84ac80c65c29f17b3e5f24993f25
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/459.0.0-2024-04-25T15:44:41.304Z/ItemConditionRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type ItemConditionRefetchQuery$variables = {
  vertical?: VerticalType | null;
};
export type ItemConditionRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ItemCondition_viewer">;
  };
};
export type ItemConditionRefetchQuery = {
  response: ItemConditionRefetchQuery$data;
  variables: ItemConditionRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vertical"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "vertical",
    "variableName": "vertical"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemConditionRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "ItemCondition_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ItemConditionRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ItemConditionDisplay",
            "kind": "LinkedField",
            "name": "itemConditionsList",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/459.0.0-2024-04-25T15:44:41.304Z/ItemConditionRefetchQuery",
    "metadata": {},
    "name": "ItemConditionRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1d852a9bd7a8ab7d2387437929b07d18";

export default node;
